'use strict';
/**
 *  Module  退稿模板
 *  createBy lvs
 * Description  2018-8-1
 */
angular.module('editNewspaperBackManuscriptModule', []).controller('editNewspaperBackManuscriptCtrl', [
    '$scope',
    '$q',
    '$modalInstance',
    '$timeout',
    '$filter',
    'initSingleSelecet',
    'trsHttpService',
    'modalDialog',
    'params',
    'editingCenterService',
    'trsspliceString',
    'globleParamsSet',
    function(
        $scope,
        $q,
        $modalInstance,
        $timeout,
        $filter,
        initSingleSelecet,
        trsHttpService,
        modalDialog,
        params,
        editingCenterService,
        trsspliceString,
        globleParamsSet
    ) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.params = {
                serviceid: 'mlf_paper',
                PaperId: params.PaperId,
            };
            $scope.status = {
                isManusCorrShow: false, //显示关联稿件
                hasNoManusCorr: false, //无关联稿件
                currItem: '', //当前选中的稿件
                currItemId: '', //当前选中稿件的 METADATAID
                currItemOriginId: '', //当前选中稿件的 ORIGINMETADATAID
                selectedType: '0', //退稿类型
                draftFrom: {
                    29: '归档稿',
                    30: '今日稿',
                    31: '待用稿',
                    32: '今日稿',
                    33: '今日稿',
                    34: '上版稿',
                    35: '已签稿',
                    36: '已签稿',
                    37: '已签稿',
                    38: '已签稿',
                },
                isRequest: false,
            };
            $scope.data = {
                items: angular.copy(params.items),
                opinion: '',
                relationDraft: [],
            };
            $scope.item = [];
        }

        /**
         * [initData 初始化数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            requestData();
        }

        /**
         * [requestData description]数据请求函数
         * @param  {[obj]} params [description]请求参数
         * @return {[obj]}        [description]请求返回值
         */
        function requestData() {
            var deffered = $q.defer();
            var isParams = {
                methodname: 'queryMetaViewDatasreturnPath',
                serviceid: 'mlf_papermodify',
                PaperDocIds: params.PaperDocIds,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), isParams, 'get').then(function(data) {
                data.forEach(function(value, index) {
                    $scope.data.items.forEach(function(value_, index_) {
                        if (value.METADATAID === value_.METADATAID) {
                            value_.RETURNPATH = value.RETURNPATH;
                        }
                    });
                });
                deffered.resolve(data);
            });
            return deffered.promise;
        }

        /**
         * [handleTitle description] 处理标题
         * @param {object} [item] [description] 列表数据
         * @return {[type]} [description]
         */
        $scope.handleTitle = function(item) {
            item.TITLE = $('<div>' + item.TITLE + '</div>').text();
        };

        /**
         * [singleDel description] 删除已选稿件
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleDel = function(item) {
            modalDialog.alertType('', '确认删除该篇退稿稿件?', 'ask', true, function() {
                $scope.data.items.splice($scope.data.items.indexOf(item), 1);
            });
        };

        /**
         * [ManusCorrToggle 打开关联稿件列表]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.ManusCorrToggle = function(item) {
            if ($scope.status.currItemId == '' || $scope.status.currItemId != item.METADATAID) {
                $scope.status.currItem = item;
                $scope.status.currItemId = item.METADATAID;
                $scope.status.currItemOriginId = item.ORIGINMETADATAID;
                $scope.status.isManusCorrShow = true;
                $scope.params.SrcDocId = item.METADATAID;
                manuscriptCorrelationData(item);
            } else if ($scope.status.currItemId == item.METADATAID) {
                $scope.status.currItemId = '';
                $scope.status.currItemOriginId = '';
                $scope.status.isManusCorrShow = false;
            }
        };

        /**
         * [manuscriptCorrelationData 获取关联稿件]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        function manuscriptCorrelationData(item) {
            var methodnameObj = {
                29: 'queryReleteDocsInGuiDang',
                30: 'queryRelateDocsInJinRi',
                31: 'queryRelateDocsInDaiYong',
                32: 'queryRelateDocsInJinRi',
                33: 'queryRelateDocsInJinRi',
                34: 'queryRelateDocsInShangBan',
                35: 'queryReleteDocsInYiQianFa',
                36: 'queryReleteDocsInYiQianFa',
                37: 'queryReleteDocsInYiQianFa',
                38: 'queryReleteDocsInYiQianFa',
            };
            $scope.params.methodname = methodnameObj[item.DOCSTATUS];
            $scope.params.PaperId = item.PAPERID || item.SITEID;
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                var signedDraftNum = 0;
                //排除已签稿
                angular.forEach(data, function(value, index) {
                    value.ORIGINMETADATAID = item.ORIGINMETADATAID;
                    if (parseInt(value.DOCSTATUS) >= 35) {
                        signedDraftNum++;
                    }
                });
                $scope.data.relationDraft = data;
                for (var i = 0; i < data.length; i++) {
                    data[i].RETURNPATH = item.RETURNPATH; //添加退回地址
                }
                $scope.status.hasNoManusCorr = data == '' ? true : false;
            });
        }

        /**
         * [indexOf description]自制indexOf，根据数组中唯一值去重
         * @param  {[type]} array [description]去重的数组
         * @param  {[type]} item  [description]单独值
         * @return {[type]}       [description]
         */
        function indexOf(array, item) {
            for (var i = 0; i <= array.length; i++) {
                if (angular.isDefined(array[i])) {
                    if (array[i].METADATAID == item.METADATAID) {
                        return i;
                    }
                }
            }
        }

        /** [chooseAllRelateDraft description]全选或者取消全选的操作 */
        $scope.chooseAllRelateDraft = function() {
            var flag = $scope.isChooseAll();
            var drafts = $scope.data.relationDraft.filter(function(item, index) {
                return item.ISXIUDING !== 'true';
            });
            for (var i in drafts) {
                var item_ = drafts[i];
                if (flag) {
                    $scope.chooseRelatedDraft(item_);
                } else {
                    var flag_ = $scope.relatedDraftIsSelected(item_).flag;
                    if (flag_) continue;
                    $scope.chooseRelatedDraft(item_);
                }
            }
        };

        /**
         * [isChooseAll description] 是否全部选中
         * @return {Boolean} [description]
         */
        $scope.isChooseAll = function() {
            var count = 0;
            var drafts = $scope.data.relationDraft.filter(function(item, index) {
                return item.ISXIUDING !== 'true';
            });
            for (var i in drafts) {
                var item_ = drafts[i];
                var flag = $scope.relatedDraftIsSelected(item_).flag;
                if (flag) {
                    count++;
                }
            }
            return count === drafts.length && drafts.length > 0;
        };

        //选择相关联的稿件
        $scope.chooseRelatedDraft = function(item) {
            var obj = $scope.relatedDraftIsSelected(item);
            if (obj.flag) {
                $scope.data.items.splice(obj.index, 1);
            } else {
                $scope.data.items.push(angular.copy(item));
            }
        };

        /**
         * [relatedDraftIsSelected description] 关联稿件是否被选中方法
         * @param {object} [item] [description] 被校验稿件
         * @return {[type]} [description]
         */
        $scope.relatedDraftIsSelected = function(item) {
            var obj = {
                flag: false,
            };
            for (var i in $scope.data.items) {
                var item_ = $scope.data.items[i];
                if (item.RECID === item_.RECID) {
                    obj.flag = true;
                    obj.index = i;
                    return obj;
                }
            }
            return obj;
        };

        /**
         * [isSelected description] 关联稿件是否处于被选择状态
         * @param  {[type]}  array [description]
         * @param  {[type]}  item  [description]
         * @return {Boolean}       [description]
         */
        $scope.isSelected = function(array, item) {
            for (var i = 0; i <= array.length; i++) {
                if (angular.isDefined(array[i])) {
                    if (array[i].METADATAID == item.METADATAID) {
                        return true;
                    }
                }
            }
        };

        /**
         * [confirm description] 确认退稿
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            var message = errorMessage();
            if (message === '') {
                $scope.status.isManusCorrShow = false;
                var rejectionParams = {
                    serviceid: 'mlf_fusionpaper',
                    methodname: 'rejectionJinRiViewDatas',
                    RejectionType: 2,
                    option: $scope.data.opinion,
                    metaDataIds: trsspliceString.spliceString($scope.data.items, 'METADATAID', ','),
                };
                rejectionParams.SrcBanMianIds = angular.isDefined($scope.data.items[0].CHNLID)
                    ? trsspliceString.spliceString($scope.data.items, 'CHNLID', ',')
                    : trsspliceString.spliceString($scope.data.items, 'CHANNELID', ',');
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), rejectionParams, 'get').then(
                    function(data) {
                        modalDialog.multiReportsAlert(data, function() {
                            $modalInstance.close('success');
                        });
                    },
                    function() {
                        $modalInstance.close();
                    }
                );
            }
        };

        /**
         * [errorMessage description]检测退稿时的操作错误并给出提示
         * @return {[str]} [description]返回提示语
         */
        function errorMessage() {
            var message = '';
            if ($scope.data.items.length === 0) {
                message = '稿件数量为零，请选择稿件后退稿';
            }
            if (message !== '') {
                modalDialog.alertType('', message, 'error', 'confirm');
            }
            return message;
        }
        
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.close();
        };
    },
]);
